import { render, staticRenderFns } from "./TzintukSettingsDialog.vue?vue&type=template&id=3fa59a32&scoped=true&"
import script from "./TzintukSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./TzintukSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./TzintukSettingsDialog.vue?vue&type=style&index=0&id=3fa59a32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa59a32",
  null
  
)

export default component.exports